import { IActionBase, IVoiceCampaignPageState } from '../models/root.interface';
import {
	ADD_CTOKEN,
	ADD_DUPLICATES,
	ADD_INVALID,
	ADD_TOTAL_CONTACTS,
	ADD_CNAME,
	ADD_CTYPE,
	ADD_RETRY,
	ADD_SOUND_ID,
	ADD_SOUND_TYPE,
	ADD_SOUND_MESSAGE,
	ADD_SCHEDULE,
	ADD_BATCH_SIZE,
	ADD_ESTIMATED_COST,
	ADD_BALANCE_LEFT,
	ADD_IS_ALLOWED,
	ADD_TOTAL_UNITS,
	ADD_SCHEDULE_INTERVAL,
	ADD_TOTAL_CHARGE,
	ADD_TOTAL_DURATION,
	ADD_TOTAL_CONTACTS_FINAL,
	ADD_SELECTED_SOUND_ID,
	ADD_TTS_FILE_PATH,
	CLEAR_TTS_FILE_PATH,
	CLEAR_SOUND_ID,
	ADD_SOUND_DURATION_TTS,
	ADD_SOUND_DURATION_SEL,
	ADD_SOUND_DURATION_UF,
	ADD_IS_POSTPAID_VC,
	ADD_FLOW_NAME,
	ADD_FLOW_ID,
	ADD_MESSAGE_PARAMS,
	ADD_FILE_COLUMN_NAMES,
	ADD_FILE_SAMPLE_DATA,
	ADD_MOBILE_NUMBER_COLUMN,
	ADD_TOTAL_CONTACTS_OBJECT,
	ADD_SCHEDULE_LATER,
	ADD_SPLIT_CAMPAIGN,
	ADD_SCHEDULED_DATE,
	ADD_SCHEDULED_TIME,
	ADD_SELECTED_SPEECH_RATE,
	ADD_SELECTED_LANGUAGE,
	ADD_AUDIO_FILE_PATH,
	ADD_REPEATED_TITLE,
	RESET_STATE,
	ADD_CURRENT_USAGE,
	ADD_SELECTED_FROM_NUMBERS
} from '../actions/voiceCampaignPage.action';

const initialState: IVoiceCampaignPageState = {
	ctoken: '',
	totalContacts: 0,
	duplicates: 0,
	invalid: 0,
	campaignName: '',
	campaignType: '',
	retry: undefined,
	soundType: '',
	soundID: [],
	message: {},
	totalUnits: 0,
	schedule: '',
	batchSize: 0,
	scheduleInterval: 0,
	estimatedCost: '',
	balanceLeft: '',
	isAllowed: -1,
	isPostpaidVC: -1,
	soundDurationTTS: 0,
	soundDurationSel: 0,
	soundDurationUF: 0,
	totalContactsFinal: 0,
	totalCharge: 0,
	totalDuration: 0,
	selectedSoundID: 0,
	TTSFilePath: '',
	flowName: undefined,
	flowId: '',
	messageParams: {},
	fileColumnNames: [],
	fileSampleData: [],
	mobileNumberColumn: '',
	totalContactsObject: {},
	splitCampaign: false,
	scheduleLater: false,
	scheduledDate: '',
	scheduledTime: '',
	speechRate: '',
	language: '',
	audioFilePath: undefined,
	repeatedTitle: '',
	currentUsage: undefined,
	dailyLimit: undefined,
	fromNumbers: [],
};
function VoiceCampaignPageReducer(
	state: IVoiceCampaignPageState = initialState,
	action: IActionBase
): IVoiceCampaignPageState {
	switch (action.type) {
		case ADD_CTOKEN: {
			return { ...state, ctoken: action.ctoken };
		}
		case ADD_TOTAL_CONTACTS: {
			return { ...state, totalContacts: action.totalContacts };
		}
		case ADD_DUPLICATES: {
			return { ...state, duplicates: action.duplicates };
		}
		case ADD_INVALID: {
			return { ...state, invalid: action.invalid };
		}
		case ADD_CNAME: {
			return { ...state, campaignName: action.campaignName };
		}
		case ADD_CTYPE: {
			return { ...state, campaignType: action.campaignType };
		}
		case ADD_RETRY: {
			return { ...state, retry: action.retry };
		}
		case ADD_SOUND_TYPE: {
			return { ...state, soundType: action.soundType };
		}
		case ADD_SOUND_ID: {
			return { ...state, soundID: action.soundID };
		}
		case ADD_SOUND_MESSAGE: {
			return { ...state, message: action.message };
		}
		case ADD_TOTAL_UNITS: {
			return { ...state, totalUnits: action.totalUnits };
		}
		case ADD_SCHEDULE: {
			return { ...state, schedule: action.schedule };
		}
		case ADD_BATCH_SIZE: {
			return { ...state, batchSize: action.batchSize };
		}
		case ADD_SCHEDULE_INTERVAL: {
			return { ...state, scheduleInterval: action.scheduleInterval };
		}
		case ADD_ESTIMATED_COST: {
			return { ...state, estimatedCost: action.estimatedCost };
		}
		case ADD_BALANCE_LEFT: {
			return { ...state, balanceLeft: action.balanceLeft };
		}
		case ADD_IS_ALLOWED: {
			return { ...state, isAllowed: action.isAllowed };
		}
		case ADD_IS_POSTPAID_VC: {
			return { ...state, isPostpaidVC: action.isPostpaidVC };
		}
		case ADD_SOUND_DURATION_TTS: {
			return { ...state, soundDurationTTS: action.soundDurationTTS };
		}
		case ADD_SOUND_DURATION_SEL: {
			return { ...state, soundDurationSel: action.soundDurationSel };
		}
		case ADD_SOUND_DURATION_UF: {
			return { ...state, soundDurationUF: action.soundDurationUF };
		}
		case ADD_TOTAL_CONTACTS_FINAL: {
			return { ...state, totalContactsFinal: action.totalContactsFinal };
		}
		case ADD_TOTAL_CHARGE: {
			return { ...state, totalCharge: action.totalCharge };
		}
		case ADD_TOTAL_DURATION: {
			return { ...state, totalDuration: action.totalDuration };
		}
		case ADD_SELECTED_SOUND_ID: {
			return { ...state, selectedSoundID: action.selectedSoundID };
		}
		case ADD_TTS_FILE_PATH: {
			return { ...state, TTSFilePath: action.TTSFilePath };
		}
		case CLEAR_TTS_FILE_PATH: {
			return { ...state, TTSFilePath: action.TTSFilePath };
		}
		case CLEAR_SOUND_ID: {
			return { ...state, soundID: [] };
		}
		case ADD_FLOW_NAME: {
			return { ...state, flowName: action.flowName };
		}
		case ADD_FLOW_ID: {
			return { ...state, flowId: action.flowId };
		}
		case ADD_MESSAGE_PARAMS: {
			return { ...state, messageParams: action.messageParams };
		}
		case ADD_FILE_COLUMN_NAMES: {
			return { ...state, fileColumnNames: action.fileColumnNames };
		}
		case ADD_FILE_SAMPLE_DATA: {
			return { ...state, fileSampleData: action.fileSampleData };
		}
		case ADD_MOBILE_NUMBER_COLUMN: {
			return { ...state, mobileNumberColumn: action.mobileNumberColumn };
		}
		case ADD_TOTAL_CONTACTS_OBJECT: {
			return {
				...state,
				totalContactsObject: action.totalContactsObject,
			};
		}
		case ADD_SPLIT_CAMPAIGN: {
			return {
				...state,
				splitCampaign: action.splitCampaign,
			};
		}
		case ADD_SCHEDULE_LATER: {
			return {
				...state,
				scheduleLater: action.scheduleLater,
			};
		}
		case ADD_SCHEDULED_DATE: {
			return {
				...state,
				scheduledDate: action.scheduledDate,
			};
		}
		case ADD_SCHEDULED_TIME: {
			return {
				...state,
				scheduledTime: action.scheduledTime,
			};
		}
		case ADD_SELECTED_SPEECH_RATE: {
			return {
				...state,
				speechRate: action.speechRate,
			};
		}
		case ADD_SELECTED_LANGUAGE: {
			return {
				...state,
				language: action.language,
			};
		}
		case ADD_AUDIO_FILE_PATH: {
			return {
				...state,
				audioFilePath: action.audioFilePath,
			};
		}
		case ADD_REPEATED_TITLE: {
			return {
				...state,
				repeatedTitle: action.repeatedTitle,
			};
		}
		case ADD_CURRENT_USAGE: {
			return {
				...state,
				currentUsage: action.currentUsage,
				dailyLimit: action.dailyLimit,
			};
		}
		case ADD_SELECTED_FROM_NUMBERS: {
			return {
				...state,
				fromNumbers: action.fromNumbers,
			};
		}
		case RESET_STATE: {
			return {
				...initialState,
			};
		}
		default:
			return state;
	}
}

export default VoiceCampaignPageReducer;
